const index = {
    state: {
        // 简历刷新标记
        resumeRefreshFlag: false,
        // 简历编辑状态
        resumeEditStatus: false,
        // 简历基础信息编辑状态
        resumeBaseInfoEditStatus: false,
        // 简历关键词编辑状态
        resumeKeywordEditStatus: false,
        // 简历工作经历编辑状态
        workExperienceEditStatus: false,
        // 简历项目经历编辑状态
        projectExperienceEditStatus: false,
        // 简历竞赛经历编辑状态
        competitionExperienceEditStatus: false,
        // 简历教育经历编辑状态
        educationExperienceEditStatus: false,
        // 简历培训经历编辑状态
        trainingExperienceEditStatus: false,
        // 简历专业技能编辑状态
        skillEditStatus: false,
        // 简历专业语言状态
        languageEditStatus: false,
        // 简历证书编辑状态
        certEditStatus: false,
        // 简历附件编辑状态
        attachmentEditStatus: false,

        // 简历名称编辑状态
        resumeNameEditStatus: false,
        // 新建简历表单显示状态
        newResumeStatus: false,
        // 企业跳转检查
        entCheckDialog:{
            check: false, // 是否检查
            targetUri: '' // 目标uri
        },
        // 需要修改新建简历表单显示状态为true的标记
        updateNewResumeStatusFlag: false,
    },
    mutations: {
        // 修改简历刷新标记
        changeResumeRefreshFlag: (state, status) => {
            state.resumeRefreshFlag = status
        },
        // 修改简历编辑状态
        changeResumeEditStatus: (state, status) => {
            state.resumeEditStatus = status
        },
        // 修改简历基础信息编辑状态
        changeResumeBaseInfoEditStatus: (state, status) => {
            state.resumeBaseInfoEditStatus = status
        },
        // 修改简历关键词编辑状态
        changeResumeKeywordEditStatus: (state, status) => {
            state.resumeKeywordEditStatus = status
        },
        // 修改简历工作经历编辑状态
        changeWorkExperienceEditStatus: (state, status) => {
            state.workExperienceEditStatus = status
        },
        // 修改简历工作经历编辑状态
        changeProjectExperienceEditStatus: (state, status) => {
            state.projectExperienceEditStatus = status
        },
        // 修改简历竞赛经历编辑状态
        changeCompetitionExperienceEditStatus: (state, status) => {
            state.competitionExperienceEditStatus = status
        },
        // 修改简历教育经历编辑状态
        changeTrainingExperienceEditStatus: (state, status) => {
            state.trainingExperienceEditStatus = status
        },
        // 修改简历培训经历编辑状态
        changeEducationExperienceEditStatus: (state, status) => {
            state.educationExperienceEditStatus = status
        },
        // 修改简历专业技能编辑状态
        changeSkillEditStatus: (state, status) => {
            state.skillEditStatus = status
        },
        // 修改简历专业语言编辑状态
        changeLanguageEditStatus: (state, status) => {
            state.languageEditStatus = status
        },
        // 修改简历证书编辑状态
        changeCertEditStatus: (state, status) => {
            state.certEditStatus = status
        },
        // 修改简历附件编辑状态
        changeAttachmentEditStatus: (state, status) => {
            state.attachmentEditStatus = status
        },

        // 修改简历名称编辑状态
        changeResumeNameEditStatus: (state, status) => {
            state.resumeNameEditStatus = status
        },
        // 修改简历表单显示状态
        changeNewResumeStatus: (state, status) => {
            state.newResumeStatus = status
        },
        // 修改简历刷新标记
        gotoEnterprise: (state, payload) => {
            state.entCheckDialog.check = payload.check
            state.entCheckDialog.targetUri = payload.targetUri
        },
        changeUpdateNewResumeStatusFlag: (state, status) => {
            state.updateNewResumeStatusFlag = status;
        }

    }
};
export default index